import iGraphType from './iGraphType';
import iGraphTitle from './iGraphTitle';
import iXAxis from './iXAxis';
import { iSeriesItem, isSeriesItem } from './iSeriesItem';
import iYAxis from './iYaxis';
import iLegend from './iLegend';
import iTooltip from './iTooltip';
import iCredits from './iCredits';
import iPlotOptions from './iPlotOptions'

export interface iGraphData {
    chart: iGraphType;
    title: iGraphTitle;
    xAxis: iXAxis;
    yAxis: iYAxis;
    series: Array<iSeriesItem>;
    legend: iLegend;
    tooltip: iTooltip;
    credits: iCredits;
    plotOptions: iPlotOptions;
    decimals?: number;
};

export default iGraphData;

export function isGraphData(obj: any): obj is iGraphData {
    return (
        obj &&
        typeof obj === 'object' &&
        typeof obj.chart === 'object' &&
        typeof obj.xAxis === 'object' &&
        typeof obj.series === 'object' &&
        Array.isArray(obj.series) &&
        (obj.series as any[]).every(s => isSeriesItem(s))
    );
};